import {apiClient} from 'core/apiClient';
import {ApiFilters, ApiPaging, ApiSortings} from 'types/api';

import {Customs, CustomsPaginationContent} from 'types/profile';

const URL = '/customs';

export async function fetchPagedCustomsList(params: {
    sortings: ApiSortings;
    filters: ApiFilters;
    paging: ApiPaging;
    searchField?: string;
}) {
    const {pageSize, pageNumber} = params.paging;
    const mappedPaging = {pageSize, pageNumber: pageNumber + 1};

    return (
        await apiClient.post<CustomsPaginationContent>(`${URL}/page`, {
            ...params,
            paging: mappedPaging,
        })
    ).data;
}

export async function fetchCustomsList() {
    return (await apiClient.get<Customs[]>(`${URL}/list`)).data;
}

export async function getCustoms(id: string | number) {
    return (await apiClient.get<Customs>(`${URL}/${id}`)).data;
}

export async function createCustoms(payload: Customs) {
    return (await apiClient.post<Customs>(URL, payload)).data;
}

export async function updateCustoms(payload: Customs) {
    const {id, ...body} = payload;
    if (!id) throw new Error('id is required');
    return (await apiClient.put<Customs>(`${URL}/${id}`, body)).data;
}

export async function removeCustoms(id: string | number) {
    return (await apiClient.delete<Customs>(`${URL}/${id}`)).data;
}
